export var ILanguages;
(function (ILanguages) {
    ILanguages["FR"] = "fr";
    ILanguages["EN"] = "en";
    ILanguages["DE"] = "de";
    ILanguages["IT"] = "it";
    ILanguages["ES"] = "es";
    ILanguages["PT"] = "pt";
})(ILanguages || (ILanguages = {}));
